import { Skeleton, Steps } from 'antd';
import { ButtonType, HtmlType, Space } from 'farmhub-ui-core';
import styled from 'styled-components';

import { useAppSelector } from 'app';
import { CButton } from 'components';
import { selectAppDevice } from 'slice';
import { theme } from 'styled';
import { DEVICES, getDummyArray } from 'utils';

import { ContentStep, MobileWrapper, Wrapper } from '../styles';

const { Step } = Steps;

const ContentSkeleton = (): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <Wrapper>
        {/* <Skeleton.Input style={{ width: 250, height: 22 }} />
        <Space height={24} /> */}
        <Steps current={-1} labelPlacement="vertical" style={{ width: 600 }}>
          {getDummyArray(3).map(item => (
            <Step
              key={item.key}
              style={{ cursor: 'pointer' }}
              title={<Skeleton.Input style={{ width: 60, height: 16 }} />}
            />
          ))}
        </Steps>
        <ContentStep>
          <Space height={36} />
          {getDummyArray(5).map(item => (
            <WrapperSkeleton key={item.key} isDesktop>
              <Skeleton.Input style={{ width: 150, height: 16 }} />
              <Space height={6} />
              <Skeleton.Button
                style={{
                  width: '100%',
                  height: theme.input.height.md,
                  borderRadius: 6,
                }}
              />
            </WrapperSkeleton>
          ))}
          <CButton
            disabled
            htmlType={HtmlType.Submit}
            type={ButtonType.Primary}
            width="420px"
          >
            Xác nhận
          </CButton>
        </ContentStep>
      </Wrapper>
    ),
    [DEVICES.MOBILE]: (
      <MobileWrapper>
        <Steps
          current={-1}
          labelPlacement="vertical"
          style={{ width: 'fit-content' }}
        >
          {getDummyArray(3).map(item => (
            <Step
              key={item.key}
              style={{ cursor: 'pointer' }}
              title={<Skeleton.Input style={{ width: 60, height: 14 }} />}
            />
          ))}
        </Steps>
        <ContentStep>
          <Space height={36} />
          {getDummyArray(5).map(item => (
            <WrapperSkeleton key={item.key}>
              <Skeleton.Input style={{ width: 150, height: 18 }} />
              <Space height={6} />
              <Skeleton.Button
                style={{
                  width: '100%',
                  height: theme.input.height.md,
                  borderRadius: 6,
                }}
              />
            </WrapperSkeleton>
          ))}
          <CButton
            disabled
            htmlType={HtmlType.Submit}
            type={ButtonType.Primary}
            width="100%"
          >
            Xác nhận
          </CButton>
        </ContentStep>
      </MobileWrapper>
    ),
    [DEVICES.TABLET]: (
      <MobileWrapper>
        <Steps
          current={-1}
          labelPlacement="vertical"
          style={{ width: 'fit-content' }}
        >
          {getDummyArray(3).map(item => (
            <Step
              key={item.key}
              style={{ cursor: 'pointer' }}
              title={<Skeleton.Input style={{ width: 60, height: 18 }} />}
            />
          ))}
        </Steps>
        <ContentStep>
          <Space height={36} />
          {getDummyArray(5).map(item => (
            <WrapperSkeleton key={item.key}>
              <Skeleton.Input style={{ width: 150, height: 18 }} />
              <Space height={6} />
              <Skeleton.Button
                style={{
                  width: '100%',
                  height: theme.input.height.md,
                  borderRadius: 6,
                }}
              />
            </WrapperSkeleton>
          ))}
          <CButton
            disabled
            htmlType={HtmlType.Submit}
            type={ButtonType.Primary}
            width="100%"
          >
            Xác nhận
          </CButton>
        </ContentStep>
      </MobileWrapper>
    ),
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default ContentSkeleton;

const WrapperSkeleton = styled.div<{ isDesktop?: boolean }>`
  width: ${p => (p.isDesktop ? '420px' : '100%')};
  padding-bottom: 24px;
  .ant-skeleton {
    width: 100%;
  }
`;
